import { useState, useEffect } from "react";
import {
  getDocumentList,
  uploadUserDocument,
} from "../../../../ApiService/ApiService";
import {
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Paper,
  IconButton,
  Avatar,
  Button,
  Typography,
  Grid,
} from "@mui/material";
import { ArrowBack, Create, UploadFileOutlined } from "@mui/icons-material";
import CustomDialog from "../../../../Components/CustomDialog";

function UploadDocuments({
  setActionComponent,
  selectedStudentId,
  studentDocuments,
}) {
  const [documentsList, setDocumentsList] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    message: "",
    buttons: [],
  });

  const fetchDocumentsList = async () => {
    try {
      const response = await getDocumentList();
      // setDocumentsList(response?.data?.data);
      const filteredDocumentsList = response?.data?.data.filter(
        (doc) =>
          !studentDocuments?.data.some(
            (studentDoc) => studentDoc.documentName === doc
          )
      );
      setDocumentsList(filteredDocumentsList);
    } catch (error) {
      console.log("Error in fetching documents list: ", error);
    }
  };

  useEffect(() => {
    fetchDocumentsList();
  }, [selectedStudentId]);

  const handleDocumentChange = (event) => {
    setSelectedDocument(event.target.value);
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
    };
    reader.readAsDataURL(selectedFile);
  };

  const handleDialogClose = () => {
    setDialog({ ...dialog, visible: false });
  };

  const handleSubmit = async () => {
    try {
      if (file && file.size > 300 * 1024) {
        setDialog({
          visible: true,
          title: "Error",
          message: "File size must be less than 300KB.",
          buttons: [{ name: "Close", onPress: handleDialogClose }],
        });
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      const response = await uploadUserDocument(
        selectedStudentId,
        selectedDocument,
        formData
      );
      // console.log("RES", response?.data);
      setDialog({
        visible: true,
        title: "Success",
        message: "Image Uploaded Successfully.",
        buttons: [{ name: "OK", onPress: handleDialogClose }],
      });
      setFile(null);
      setPreview(null);
    } catch (error) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Something went wrong",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
    }
  };

  const getURL = (selectedDocument) => {
    const selectedDocumentUrl =
      studentDocuments?.data?.find(
        (doc) => doc.documentName === selectedDocument
      )?.documentUrl || "";
    return selectedDocumentUrl;
  };

  // console.log("DocumentsList", documentsList);
  // console.log("StudentsDocuments", studentDocuments);

  return (
    <>
      <CustomDialog
        visible={dialog.visible}
        title={dialog.title}
        message={dialog.message}
        buttons={dialog.buttons}
        onClose={handleDialogClose}
      />
      <Box sx={{ width: "100%" }}>
        <Paper
          elevation={3}
          sx={{
            padding: 3,
            marginTop: 2,
            marginBottom: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {" "}
          <FormControl
            fullWidth
            size="small"
            sx={{
              marginTop: 2,
              width: "75%",
            }}
          >
            <InputLabel id="document-select-label">Select Document</InputLabel>
            <Select
              labelId="document-select-label"
              id="document-select"
              value={selectedDocument}
              onChange={handleDocumentChange}
              label="Select Document"
            >
              {documentsList?.map((document) => (
                <MenuItem key={document} value={document}>
                  {document}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box sx={{ position: "relative", display: "inline-block" }}>
            <Avatar
              src={preview ? preview : getURL(selectedDocument)}
              alt="Profile"
              sx={{
                height: 240,
                width: 240,
                border: "1px solid gray",
                marginBottom: 3,
                marginTop: 3,
              }}
            />

            <IconButton
              size="large"
              onClick={() => {
                const fileInput = document.getElementById(
                  "contained-button-file"
                );
                fileInput.click();
              }}
              sx={{
                position: "absolute",
                bottom: 5,
                left: 100,
                color: "white",
                backgroundColor: "#2659c8",
                borderRadius: "50%",
                "&:hover": {
                  backgroundColor: "white",
                  border: "1px solid #2659c8",
                  color: "#2659c8",
                },
              }}
            >
              <Create />
            </IconButton>
          </Box>
          <input
            accept="image/*"
            style={{ display: "none" }}
            id="contained-button-file"
            type="file"
            onChange={handleFileChange}
          />
          <Typography variant="subtitle1" color="error" sx={{ marginTop: 1 }}>
            Note: File size should be less than 300KB
          </Typography>
          <Grid container justifyContent="center" alignItems="center">
            <Grid item>
              <Button
                fullWidth
                variant="contained"
                color="inherit"
                onClick={() => setActionComponent(null)}
                startIcon={<ArrowBack sx={{ marginLeft: 1 }} />}
                sx={{
                  textTransform: "unset",
                  marginTop: 2,
                  marginBottom: 1,
                  marginLeft: 3,
                  marginRight: 3,
                  width: 200,
                }}
              >
                Back
              </Button>
            </Grid>
            <Grid item>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                size="small"
                onClick={handleSubmit}
                disabled={!file}
                sx={{
                  textTransform: "unset",
                  marginTop: 2,
                  marginBottom: 1,
                  marginLeft: 3,
                  marginRight: 3,
                  height: 40,
                  width: 200,
                }}
              >
                Upload <UploadFileOutlined sx={{ marginLeft: 1 }} />
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </>
  );
}

export default UploadDocuments;
